import { jsx as _jsx } from "react/jsx-runtime";
import { PlaylistForm } from '../features/savedItems';

const CreatePlaylist = () => {
  return /*#__PURE__*/_jsx(PlaylistForm, {
    action: "create"
  });
};

export default CreatePlaylist;